import React from 'react';

const Gallery = () => {
  const galleryItems = [
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/097uhqzg_IMG_8499.jpeg',
      title: 'Blonde Transformation',
      description: 'Natural blonde with dimension',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/q21nuztm_IMG_8501.jpeg',
      title: 'Rich Brunette',
      description: 'Deep chocolate brunette',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/iaodyvau_IMG_8502.jpeg',
      title: 'Dimensional Blonde',
      description: 'Dimensional blonde perfection',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/vi4hug1f_IMG_8503.jpeg',
      title: 'Buttery Blonde',
      description: 'Soft buttery blonde waves',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/aujb1rfp_IMG_8504.jpeg',
      title: 'Colour Process',
      description: 'Behind the transformation',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/pmvzlgw9_IMG_8500.jpeg',
      title: 'Styling Artistry',
      description: 'Precision styling in action',
    },
  ];

  return (
    <section id="gallery" className="py-20 md:py-32 bg-sage-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-gray-900 mb-4 md:mb-6">
            Our Work
          </h2>
          <p className="text-base md:text-lg text-gray-700 font-light leading-relaxed max-w-2xl mx-auto">
            Browse our portfolio of transformations and find your inspiration.
          </p>
        </div>

        {/* Gallery Grid - Mobile: 2 columns, Desktop: 3 top + 3 bottom */}
        <div>
          {/* Desktop Layout */}
          <div className="hidden md:block">
            {/* Top Row: 3 images */}
            <div className="grid grid-cols-3 gap-8 mb-8">
              {galleryItems.slice(0, 3).map((item, idx) => (
                <div
                  key={idx}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={item.src}
                      alt={item.title}
                      className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ${
                        item.cropBottom ? 'object-[center_35%]' : ''
                      }`}
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      <h3 className="text-xl font-normal mb-1">{item.title}</h3>
                      <p className="text-sm font-light opacity-90">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Bottom Row: 3 images */}
            <div className="grid grid-cols-3 gap-8">
              {galleryItems.slice(3, 6).map((item, idx) => (
                <div
                  key={idx + 3}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={item.src}
                      alt={item.title}
                      className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ${
                        item.cropBottom ? 'object-[center_35%]' : ''
                      }`}
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      <h3 className="text-xl font-normal mb-1">{item.title}</h3>
                      <p className="text-sm font-light opacity-90">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Layout: 2 column grid */}
          <div className="md:hidden grid grid-cols-2 gap-3">
            {galleryItems.map((item, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={item.src}
                    alt={item.title}
                    className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ${
                      item.cropBottom ? 'object-[center_35%]' : ''
                    }`}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-xl font-normal mb-1">{item.title}</h3>
                    <p className="text-sm font-light opacity-90">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="sms:0475409162"
            className="inline-flex items-center justify-center bg-sage-600 text-white px-10 py-4 rounded-full hover:bg-sage-700 transition-all duration-300 font-normal tracking-wide shadow-lg hover:shadow-xl"
          >
            READY FOR YOUR TRANSFORMATION?
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;